if (!customElements.get('badge-component')) {
  class BadgeComponent extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('[triger-drawer-button]');
      this.getPortalElementId = this.getAttribute('target-portal-element') || null;
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.openDrawer.bind(this, button));
      });
    }

    openDrawer(button) {
      window.currentActiveElement = button;
      const drawerContent = button.querySelector('[drawer-content]').innerHTML;
      HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showDrawer, document, {
        drawerType: 'badge-drawer',
        content: drawerContent,
        portalDrawerTo: this.getPortalElementId,
        portalBackSectionId: this.id,
      });
    }
  }

  customElements.define('badge-component', BadgeComponent);
}

if (!customElements.get('badge-content')) {
  class BadgeContent extends HTMLElement {
    constructor() {
      super();
      this.contentWrapper = this.querySelector('[content-wrapper]');
      document.addEventListener(_EVENT_HELPER.showDrawer, this.showDrawer.bind(this));
      document.addEventListener(_EVENT_HELPER.hideDrawer, this.hideDrawer.bind(this));
    }

    showDrawer(event) {
      this.contentWrapper.innerHTML = event.detail.content;
    }

    hideDrawer() {
      setTimeout(() => {
        this.contentWrapper.innerHTML = '';
      }, 300);
    }
  }

  customElements.define('badge-content', BadgeContent);
}

if (!window.__productBadgesScrollEnhancerLoaded) {
  window.__productBadgesScrollEnhancerLoaded = true;

  const badgeSliderSelector = '.product-badges--style-wrap';
  const initializedBadgeSliders = new Set();

  function getBadgeScrollbarParts(slider) {
    const bar = slider.nextElementSibling?.matches?.('[data-badge-scrollbar]')
      ? slider.nextElementSibling
      : null;

    return {
      bar,
      fill: bar?.querySelector('[data-badge-scrollbar-fill]') || null,
    };
  }

  function createBadgeScrollbar(slider) {
    const existingParts = getBadgeScrollbarParts(slider);
    if (existingParts.bar && existingParts.fill) return existingParts;

    const bar = document.createElement('div');
    bar.setAttribute('data-badge-scrollbar', '');
    bar.style.cssText = `
      height: 4px;
      background: #e0e0e0;
      border-radius: 99px;
      margin: -24px 0 16px;
      overflow: hidden;
      display: none;
    `;

    const fill = document.createElement('div');
    fill.setAttribute('data-badge-scrollbar-fill', '');
    fill.style.cssText = `
      height: 100%;
      background: var(--color-button-background, #000);
      border-radius: 99px;
      width: 33%;
      transition: transform 0.15s ease;
      transform-origin: left;
    `;

    bar.appendChild(fill);
    slider.parentNode?.insertBefore(bar, slider.nextSibling);

    return { bar, fill };
  }

  function updateBadgeScrollbar(slider) {
    const { bar, fill } = createBadgeScrollbar(slider);
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const isScrollable = maxScroll > 0;

    bar.style.display = isScrollable ? 'block' : 'none';

    if (!isScrollable) {
      fill.style.transform = 'translateX(0)';
      return;
    }

    const progress = slider.scrollLeft / maxScroll;
    const travel = bar.clientWidth - fill.clientWidth;
    fill.style.transform = `translateX(${progress * travel}px)`;
  }

  function initBadgeSlider(slider) {
    if (!(slider instanceof HTMLElement) || initializedBadgeSliders.has(slider)) return;

    initializedBadgeSliders.add(slider);
    slider.addEventListener(
      'scroll',
      () => {
        updateBadgeScrollbar(slider);
      },
      { passive: true }
    );

    updateBadgeScrollbar(slider);
  }

  function initBadgeSliders(root = document) {
    const sliders = [];

    if (root instanceof HTMLElement && root.matches(badgeSliderSelector)) {
      sliders.push(root);
    }

    if (root.querySelectorAll) {
      sliders.push(...root.querySelectorAll(badgeSliderSelector));
    }

    sliders.forEach(initBadgeSlider);

    if (sliders.length > 0) {
      requestAnimationFrame(() => {
        sliders.forEach(updateBadgeScrollbar);
      });
    }
  }

  function refreshAllBadgeSliders() {
    initializedBadgeSliders.forEach((slider) => {
      if (!slider.isConnected) {
        initializedBadgeSliders.delete(slider);
        return;
      }

      updateBadgeScrollbar(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBadgeSliders(document));
  } else {
    initBadgeSliders(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBadgeSliders(event.target);
  });

  window.addEventListener('resize', refreshAllBadgeSliders);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        initBadgeSliders(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
